import { createRoot } from "react-dom/client";
import ProfileImage from "./components/ProfileImage";
import TypedSubtitle from "./components/TypedSubtitle";
import ScrollProgress from "./components/ScrollProgress";
import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

// Profile image with hover effects
const profileRoot = document.getElementById("profile-image-root");
if (profileRoot) createRoot(profileRoot).render(<ProfileImage width={220} />);

// Typed cycling subtitle
const subtitleRoot = document.getElementById("subtitle-root");
if (subtitleRoot) createRoot(subtitleRoot).render(<TypedSubtitle />);

// Scroll progress bar
const progressMount = document.createElement("div");
document.body.prepend(progressMount);
createRoot(progressMount).render(<ScrollProgress />);

// Section title left-border animation on scroll into view
const titleObserver = new IntersectionObserver(
  (entries) =>
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add("title-in-view");
        titleObserver.unobserve(e.target);
      }
    }),
  { threshold: 0.3 }
);
document.querySelectorAll(".section-title").forEach((el) =>
  titleObserver.observe(el)
);

initScrollReveal(targetElements, defaultProps);
initTiltEffect();
